import * as types from "./actionTypes"

export function setUserData(value: any) {
  return { type: types.SET_USER_DATA, value }
}
